import { push } from "react-router-redux";
import { NAVIGATE_CLAIMS, NAVIGATE_EMERGENCY, NAVIGATE_HOME, NAVIGATE_OTHER, SET_CUSTOMER_DATA, NAVIGATE_FNOL, NAVIGATE_PERSONAL_INSURANCE, NAVIGATE_PERSONAL_DETAILS, NAVIGATE_REQUEST_DOCUMENTS, NAVIGATE_DONATE_MY_DECREASE, NAVIGATE_REFER_A_FRIEND, NAVIGATE_MY_QUOTE, NAVIGATE_CONTACT_US, NAVIGATE_LIFE_INSURANCE, NAVIGATE_FNOL_SUBMIT_CLAIM, NAVIGATE_CLAIM_HISTORY_V2, SET_CLAIM_DATA, SET_CART_DATA, SET_QUOTE_DATA, QUOTE_LOADING_SCREEN_SHOW, QUOTE_LOADING_SCREEN_HIDE } from "../constants/constants";
import { CLAIMS, DASHBOARD, EMERGENCY_ASSISTANCE, HOME, FNOL, PERSONAL_INSURANCE, PERSONAL_DETAILS, REQUEST_DOCUMENTS, DONATE_MY_DECREASE, REFER_A_FRIEND, MY_QUOTE, CONTACT_US, LIFE_INSURANCE, FNOL_SUBMIT_CLAIM, CLAIM_HISTORY_V2, BANKING_DETAILS, FNOL_CLAIM_PROGRESS_MOBILE, QUOTATION } from "../routes/routes";
import { setCurrentScreen } from "../firebase/firebase";
import { showClickawayFollowUp, showInEditRemoveScreen, showInEditScreen, showQuoteEditScreen } from '../actions/modalActions';
import { postToController } from "./apiActions";
import {showModalCalculatorBroke} from "./salesModalActions";


export const navigateTo = (destination: any) => {

    setCurrentScreen(destination);
    return async (dispatch, getState) => {
        if (getState().sales.isInEdit) {
            dispatch(showInEditScreen("", destination));
        }
        else if (getState().sales.isInRemove) {
            dispatch(showInEditRemoveScreen("", destination));
        }
        else if (getState().sales.isQuoteScreen && destination !== BANKING_DETAILS && destination !== QUOTATION) {
            dispatch(showQuoteEditScreen("", destination));
        }
        else if (getState().claimSubmit.followUp && (destination !== FNOL_CLAIM_PROGRESS_MOBILE && destination !== FNOL_SUBMIT_CLAIM)) {
            dispatch(showClickawayFollowUp("", destination));
        }
        else {
            if (destination === DASHBOARD) {
                dispatch({
                    type: NAVIGATE_HOME,
                });
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: true,
                    }
                });
            }
            else if (destination === CLAIMS) {
                dispatch({
                    type: NAVIGATE_CLAIMS,
                });
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
            else if (destination === FNOL) {
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        showDisclaimer: false,
                    }
                });
                dispatch({
                    type: NAVIGATE_FNOL,
                });
            }
            else if (destination === FNOL_SUBMIT_CLAIM) {
                await dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        showDisclaimer: false,
                        fnolStep: 1,
                        fnolSubStep: 1,
                    }
                });
                dispatch({
                    type: NAVIGATE_FNOL_SUBMIT_CLAIM,
                });
            }
            else if (destination === CLAIM_HISTORY_V2) {
                dispatch({
                    type: NAVIGATE_CLAIM_HISTORY_V2,
                });
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
            else if (destination === HOME) {
                dispatch({
                    type: DASHBOARD,
                });
            }
            else if (destination === EMERGENCY_ASSISTANCE) {
                dispatch({
                    type: NAVIGATE_EMERGENCY,
                });
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
            else if (destination === PERSONAL_INSURANCE) {
                dispatch({
                    type: NAVIGATE_PERSONAL_INSURANCE,
                });
            }
            else if (destination === LIFE_INSURANCE) {
                dispatch({
                    type: NAVIGATE_LIFE_INSURANCE,
                });
            }

            else if (destination === PERSONAL_DETAILS) {
                dispatch({
                    type: NAVIGATE_PERSONAL_DETAILS,
                });
            }

            else if (destination === REQUEST_DOCUMENTS) {
                dispatch({
                    type: NAVIGATE_REQUEST_DOCUMENTS,
                });
            }

            else if (destination === DONATE_MY_DECREASE) {
                dispatch({
                    type: NAVIGATE_DONATE_MY_DECREASE,
                });
            }

            else if (destination === REFER_A_FRIEND) {
                dispatch({
                    type: NAVIGATE_REFER_A_FRIEND,
                });
            }

            else if (destination === MY_QUOTE) {
                dispatch({
                    type: NAVIGATE_MY_QUOTE,
                });
            }

            else if (destination === CONTACT_US) {
                dispatch({
                    type: NAVIGATE_CONTACT_US,
                });
            }
            else if (destination === FNOL_CLAIM_PROGRESS_MOBILE) {
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
            else if (destination === BANKING_DETAILS) {
            dispatch({ type: QUOTE_LOADING_SCREEN_SHOW });
                await postToController(dispatch, 'GetCartData', JSON.stringify({
                    Parameter: getState().sales.quoteId,
                })).then(async (cartProducts) => {
                    await postToController(dispatch, 'GetBankingDetails', JSON.stringify({
                        PolicyId: getState().profile.policyId,
                        QuoteId: getState().sales.quoteId
                    })).then(async (response) => {
                        if (cartProducts.premiumCalculationError){
                            dispatch(showModalCalculatorBroke());
                        }
                        else {
                            if (response) {
                                await dispatch({
                                    type: SET_CUSTOMER_DATA, payload: {
                                        bankingDetails: response,
                                    }
                                })
                                await dispatch({
                                    type: SET_CART_DATA, payload: {
                                        products: cartProducts.products,
                                        quote: getState().sales.quote,
                                        quoteId: getState().sales.quoteId,
                                        premiumCalculationError: cartProducts.premiumCalculationError
                                    }
                                });
                                await dispatch({
                                    type: SET_QUOTE_DATA, payload: {
                                        carPremium: cartProducts.premuim,
                                        proRata: cartProducts.proRata
                                    }
                                });
                            }
                        }
                    })
                })
                dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            }
            else {
                dispatch({
                    type: NAVIGATE_OTHER,
                });
                dispatch({
                    type: SET_CUSTOMER_DATA, payload: {
                        showMobileProfile: false,
                    }
                });
            }
            window.scrollTo(0, 0);
            dispatch(push(destination));
        }
    }
}